import { render, staticRenderFns } from "./TwoStepCreate.vue?vue&type=template&id=ca1c81f4&"
import script from "./TwoStepCreate.vue?vue&type=script&lang=js&"
export * from "./TwoStepCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports